export const isString = (object: unknown): object is string =>
  typeof object === "string" || object instanceof String;

export const isEmpty = (val: any): val is undefined | null =>
  val === undefined || val === null;
export const isNotEmpty = <T>(val: T | undefined | null): val is T =>
  !isEmpty(val);
